import React from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import Products from "@/components/landing/Products";
import Process from "@/components/landing/Process";
import Partners from "@/components/landing/Partners";
import Testimonials from "@/components/landing/Testimonials";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import { Toaster } from "sonner";

export default function LandingPage() {
  return (
    <main
      data-testid="landing-page"
      className="relative w-full bg-[#F8F9FA] text-slate-900"
    >
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Products />
      <Process />
      <Partners />
      <Testimonials />
      <Contact />
      <Footer />
      <Toaster position="bottom-right" richColors />
    </main>
  );
}
